<router-outlet *ngIf="applications.pages | async"></router-outlet>
